<template>
  <div class="row align-center justify-middle">
    <div class="meteor-floor" />
    <div class="meteor" />

    <div class="text-content">
      <div class="text-header">
        {{ title }}
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFoundMeteor",
  props: {
    title: {
      type: String,
      default: "404",
    },
    body: {
      type: String,
      default: "Ops! Algo deu errado.",
    },
  },
};
</script>

<style scoped>
.text-content {
  position: relative;
  text-align: center;
  margin-bottom: 150px;
}

h1,
h2,
h3,
h4,
h5,
.text-header {
  font-family: Ubuntu;
  font-size: 70px;
  font-weight: bold;
  color: #565656;
}

p,
.text-body {
  font-family: Ubuntu;
  font-size: 22px;
  text-align: center;
  margin-bottom: 0;
  color: #565656;
}

.meteor {
  position: absolute;
  bottom: 0;
  right: 0;
  /*top: -100%;*/
  /*right: -100%;*/

  background: url(/static/404-meteoro.svg);
  width: 190px;
  height: 190px;
  background-repeat: no-repeat;
  background-position: center center;

  animation: anim-meteor 20s infinite linear;
}

.meteor-floor {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  background: url(/static/404-chao.svg);
  height: 300px;
  max-height: 100%;
  min-height: 300px;
  background-repeat: repeat-x;
  background-position: bottom left;
}

@keyframes anim-meteor {
  0% {
    opacity: 0;
    transform: translate3d(-50%, -300%, 0);
  }

  5% {
    opacity: 1;
  }

  95% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: translate3d(-250%, -100%, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NotFoundMeteor.vue